<div class="tasks-list--container">
  <div class="aggregate-card--container-header">
    <forge-toolbar no-border>
      <h2 slot="start" class="forge-typography--heading4">{{header}}</h2>
      @if (!loaded) {
        <busy-indicator slot="center"></busy-indicator>
      }
      <forge-icon-button slot="end" (click)="displayOrdering()" tabindex="0" aria-haspopup="true" aria-label="Smart Card settings"
        telemetry="Smart Card settings">
        <forge-tooltip>Smart Card settings</forge-tooltip>
        <forge-icon name="settings"></forge-icon>
      </forge-icon-button>
    </forge-toolbar>
  </div>

  @if (showNoTasksMsg) {
    <div>
      <span class="forge-typography--body1">No smart cards to review</span>
    </div>
  }

  @if (loaded) {
    <div>
      <div>
        <forge-accordion panel-selector="forge-expansion-panel">
          <aggregate-collection [aggregateCriterias]="aggregateCriterias">
          </aggregate-collection>
        </forge-accordion>
      </div>
    </div>
  }
</div>
